/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 29njzcsBEPR4koRddw4knF

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 29njzcsBEPR4koRddw4knF/projectModule

import "../PP__plasmickit_alert_banner.css"; // plasmic-import: 29njzcsBEPR4koRddw4knF/projectcss
import "../PP__plasmickit_design_system.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss

const data = {
  base: `${"plasmic_tokens_29njzcsBEPR4koRddw4knF"} ${"plasmic_tokens_tXkSR39sgCDWSitZxC5xFV"} ${"plasmic_tokens_95xp9cYcv7HrNWpFWWhbcv"}`,
  varianted: [],
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
